<template>
    <div id="submitQ">
        <div class="line">
            <label>ICCID号：</label>
            <div><span>{{data.recordLoginText}}</span></div>
        </div>
        <div class="line">
            <label>问题描述：</label>
            <div class="moreInfo">
                <textarea v-model="data.problemContent" rows="4"></textarea>  
            </div>                    
        </div>
        <div>
            <mt-button type="primary" size="large" @click="submitFeedbackHandler">提交</mt-button>
        </div>
    </div>
</template>
<script>
import {submitFeedback, wxRequest} from '@/api/user'
export default {
    data(){
        return {
            data: {
                iccid: this.$store.state.iccid,
                problemContent: '' ,
                recordLoginText:this.$store.state.recordLoginText               
            }

        }
    },
    methods: {
        submitFeedbackHandler(){
            var data = this.data;
            wxRequest("userProblem/add", data, "post").then(res => {
                if(res.data.code == 200){
                    this.$toast({
                        message: '提交成功',
                        position: 'middle',
                        duration: 1500
                    })
                    this.data.problemContent = '';
                }else{
                    this.$toast({
                        message: res.data.message,
                        position: 'middle',
                        duration: 1500
                    })
                }
            })
        }
    }
}
</script>
<style lang="less">
#submitQ {
    margin-top: 10px;
    height: calc(100% - 40px);
    padding: 20px 4%;
    background: #fff;
}
</style>
